import { LitElement } from 'lit'
import { reporter } from 'components/shared/reporter/reporter.js'

export function required() {
  return function checkProperty<T extends LitElement>(target: T, propertyKey: string | symbol): void {
    const originalConnectedCallback = target.connectedCallback

    target.connectedCallback = function() {
      if (this[propertyKey as keyof T] === undefined) {
        const propertyName = String(propertyKey)
        const componentTag = customElements.getName(target.constructor as new () => T)
        reporter.error(`Property "${propertyName}" of "${componentTag}" is required!`)
      }

      originalConnectedCallback.call(this)
    }
  }
}
